var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyCardE3A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 158,
    height: 158,
    rx: 12,
    fill: "#fff",
    stroke: "#FA8300",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.274 111.318c-30.281-12.725-18.332-55.682 2.69-62.778 8.721-2.944 18.34 6.824 18.282 12.887-.028 2.622-1.386 5.18-2.801 7.843-1.857 3.5-3.813 7.18-2.983 11.437 1.463 7.499 3.102 20.152-1.12 26.156-4.223 6.008-8.468 6.808-14.068 4.455zM111.035 48.54c21.022 7.096 32.974 50.053 2.69 62.778-5.6 2.355-9.845 1.553-14.068-4.455-4.222-6.004-2.584-18.657-1.12-26.156.83-4.258-1.126-7.94-2.983-11.437-1.416-2.664-2.773-5.221-2.798-7.843-.061-6.063 9.56-15.831 18.279-12.887zM95.066 89.174l.195 2.769h.033l.009-.003a3.598 3.598 0 0 0-.469.1 4.331 4.331 0 0 0-1.318.628c-.808.572-1.996 1.844-1.996 5.054V114a2 2 0 0 1-2 2h-1.574a2 2 0 0 1-2-2V97.722c0-4.904 1.979-7.906 4.334-9.581a9.924 9.924 0 0 1 4.07-1.675c.147-.023.296-.042.445-.055l.045-.006h.03c0-.003.006-.003.196 2.769zM68.933 89.174c-.19 2.769-.193 2.769-.196 2.769h-.033l-.008-.003.067.008a4.335 4.335 0 0 1 1.72.717c.808.575 1.995 1.847 1.995 5.057V114a2 2 0 0 0 2 2h1.575a2 2 0 0 0 2-2V97.722c0-4.904-1.98-7.906-4.337-9.581a9.92 9.92 0 0 0-4.07-1.675 6.888 6.888 0 0 0-.446-.055l-.042-.006h-.03c0-.003-.003-.003-.195 2.769z",
    fill: "#AD6565"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyCardE3A);
export default __webpack_public_path__ + "static/media/kidneyCardE3a.d533e6f7.svg";
export { ForwardRef as ReactComponent };